import { apiUtils } from "@/utils/apiUtils";

export const addressService = {
  async getAll() {
    try {
      const result = await apiUtils.doGet('/TCPAddrBookJ.action', {
        json: "true",
      });
      return result;
    } catch (error) {
      console.error("Error on getting addresses:", error);
      throw error;
    }
  },
  async getById(addressId) {
    try {
      const result = await apiUtils.doGet('/TCPEditAddrJ.action', {
        json: "true",
        addrId: addressId,
      });
      return result;
    } catch (error) {
      console.error("Error on getting address by id:", error);
      throw error;
    }
  },
  async createAddress(address) {
    try {
      const result = await apiUtils.doPost('/TCPNewAddrSubmitJ.action', {
        json: "true",
        countryChange: "0",
        ...address,
      });
      return result;
    } catch (error) {
      console.error("Error on creating address:", error);
      throw error;
    }
  },
  async editAddress(address) {
    try {
      const result = await apiUtils.doPost('/TCPEditAddrSubmitJ.action', {
        json: "true",
        countryChange: "0",
          ...address,
      });
      return result;
    } catch (error) {
      console.error("Error on editing address:", error);
      throw error;
    }
  },
  async deleteById(addressId) {
    try {
      const result = await apiUtils.doPost('/TCPDeleteAddrSubmitJ.action', {
        json: "true",
        addrId: addressId,
      });
      return result;
    } catch (error) {
      console.error("Error on deleting address:", error);
      throw error;
    }
  },
  async setAsPrimary(address) {
    try {
      const result = await apiUtils.doPost('/TCPEditAddrSubmitJ.action', {
        json: "true",
        countryChange: "0",
        ...address,
        setAsPrimaryBool: true
      });
      return result;
    } catch (error) {
      console.error("Error on editing address:", error);
      throw error;
    }
  },
  async changeById(addressId) {
    try {
      const result = await apiUtils.doPost('/TCPCheckoutChangeDeliveryAddrJ.action', {
        json: "true",
        addrId: addressId,
      });
      return result;
    } catch (error) {
      console.error("Error on changing address:", error);
      throw error;
    }
  },
};
